export const CUSTOMER_GROUP = {
  CANHAN: 'Cá nhân',
  GIADINH: 'Gia đình',
  NHOMBANBE: 'Nhóm bạn bè',
  HOINHOM: 'Hội nhóm',
  DOANHNGHIEP: 'Doanh nghiệp'
}
